module.exports = __webpack_public_path__ + "img/zhmzxzz98.d83ca556.png";